var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3032_37593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2854 0H3.10683C3.0479 0 2.99969 0.0482143 2.99969 0.107143V0.857143C2.99969 0.916071 3.0479 0.964286 3.10683 0.964286H9.74969V10.1786C9.74969 10.2375 9.7979 10.2857 9.85683 10.2857H10.6068C10.6658 10.2857 10.714 10.2375 10.714 10.1786V0.428571C10.714 0.191518 10.5225 0 10.2854 0ZM8.57112 1.71429H1.71397C1.47692 1.71429 1.2854 1.9058 1.2854 2.14286V9.25045C1.2854 9.36429 1.33094 9.47277 1.41129 9.55313L3.73228 11.8741C3.76174 11.9036 3.79522 11.9277 3.83138 11.9478V11.9732H3.88763C3.93451 11.9906 3.98406 12 4.03495 12H8.57112C8.80817 12 8.99969 11.8085 8.99969 11.5714V2.14286C8.99969 1.9058 8.80817 1.71429 8.57112 1.71429ZM3.83004 10.6098L2.67692 9.45536H3.83004V10.6098ZM8.0354 11.0357H4.68719V9.13393C4.68719 8.83795 4.44745 8.59821 4.15147 8.59821H2.24969V2.67857H8.0354V11.0357Z",
    fill: "current",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3032_37593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.1ed77d6076c842d63a80fdb6415e9c2a.svg";
export { ForwardRef as ReactComponent };